import { render, staticRenderFns } from "./PodtEdit.vue?vue&type=template&id=3e157683&scoped=true&"
import script from "./PodtEdit.vue?vue&type=script&lang=js&"
export * from "./PodtEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e157683",
  null
  
)

export default component.exports